export const getThemeSpacingFromUnit = (unit: number) => {
  return unit * 8;
};
